import { PROJECTS_ENDPOINT } from "Constants";
import { uploadFile as uploadVersion } from "Services";
import { VersionSoftwareInfo } from "Types";
import { apiErrorToast } from "Utils";

const useFileUpload = (packageId: string) => {
  const uploadFile = async (
    file: File | null,
    softwareInfo: VersionSoftwareInfo,
  ) => {
    if (!file) return;

    const formData = new FormData();

    formData.append("file", file, file.name);
    formData.append("product", softwareInfo.product);
    formData.append("publisher", softwareInfo.publisher);
    formData.append("version", softwareInfo.version);
    formData.append("category", softwareInfo.category);
    formData.append("license", softwareInfo.license);
    formData.append("platform", softwareInfo.platform);
    formData.append("architecture", softwareInfo.architecture);
    formData.append("force", (softwareInfo.force ?? false).toString());
    formData.append("replace", (softwareInfo.replace ?? false).toString());
    formData.append(
      "is_released",
      (softwareInfo.is_released ?? false).toString(),
    );
    formData.append(
      "notify_on_completion",
      softwareInfo.notify_on_completion.toString(),
    );
    formData.append("package_id", packageId || "");

    if (softwareInfo.release_date) {
      formData.append("release_date", softwareInfo.release_date);
    }

    if (softwareInfo.predecessor_id) {
      formData.append("predecessor_id", softwareInfo.predecessor_id);
    }

    try {
      await uploadVersion(`${PROJECTS_ENDPOINT}/versions/upload`, formData, 1);
    } catch (error) {
      apiErrorToast(error, "Could not upload the release version");
    }
  };

  return {
    uploadFile,
  };
};

export default useFileUpload;
